<template>
  <template v-if="!edit">
    <ul v-if="value && Array.isArray(value) && value.length" class="text-sm list-inline">
      <li v-for="(val, index) in value" :key="index">
        {{ val }}
      </li>
    </ul>
    <span v-else class="text-sm">
      Sem resposta 
    </span>
  </template>
  
  <MultiselectAnswer v-else v-bind="$attrs" no-label :question="original"/>
</template>

<script>

import MultiselectAnswer from '#views/questionnaire/answers/MultiselectAnswer';

export default {
  name: "MultiselectDetail",
  inheritAttrs: false,
  components: {
    MultiselectAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  }
};
</script>
